'use strict';

function fSliderTimeline () {
    const aSliders = document.querySelectorAll('.js-timeline');
    
    function fInitSlider (oSlider) {
        const oList = oSlider.querySelector('.js-timeline-list');
        const aListItems = oList.querySelectorAll('.timeline__item');
        const oNav = oSlider.querySelector('.js-timeline-nav');
        const oButtonPrev = oSlider.querySelector('.js-timeline-prev');
        const oButtonNext = oSlider.querySelector('.js-timeline-next');

        for (var a = 0; a < aListItems.length; a += 1) {
            aListItems[a].style.width = aListItems[a].offsetWidth + 'px';
        }
        oList.style.display = 'block';

        let oFlickity = new Flickity(oList, {
            cellAlign: 'left',
            contain: true,
            freeScroll: true,
            pageDots: false,
            on: {
                ready: function () {
                    if (oNav) oNav.style.display = 'block';
                    if (oButtonPrev) oButtonPrev.addEventListener('click', function () { oFlickity.previous(); });
                    if (oButtonNext) oButtonNext.addEventListener('click', function () { oFlickity.next(); });
                },
                change: function (index) {
                    if (oFlickity.selectedIndex + 1 === oFlickity.slides.length) {
                        oButtonNext.style.opacity = 0;
                    } else {
                        oButtonNext.style.opacity = 1;
                    }

                    if (index > 0) {
                        oButtonPrev.style.opacity = 1;
                    } else {
                        oButtonPrev.style.opacity = 0;
                    }
                }
            }
        });
    }

    for (let a = 0; a < aSliders.length; a += 1) {
        fInitSlider(aSliders[a]);
    }
}